import Text from 'components/Text/Text';
import React from 'react';
import { IModifiersForModifierGroups } from 'types';
import style from './ModifiersScrollView.module.scss';

interface IDishesScrollView {
	data: IModifiersForModifierGroups[];
}

const ModifiersScrollView: React.FC<IDishesScrollView> = ({ data }) => {
	return (
		<div className={style.container} data-test="ModifiersScrollView">
			{data.length
				? data.map((el) => (
						<div key={el.modifierId} className={style.item}>
							<div className={style.dot} />
							<Text translationKey={el.modifierName} withTooltip={true} />
						</div>
				  ))
				: '-'}
		</div>
	);
};

export default React.memo(ModifiersScrollView);
